<template>
  <b-modal ref="make-payment-ref" hide-footer hide-header>
    <!-- no-close-on-backdrop + also add a cancel button so they have more exits -->
    <div class="vtd-modal-content">
      <div class="vtd-modal-header mb-1">
        <h5 class="vtd-modal-title">Make a Payment</h5>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
          id="close-make-payment-modal"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>

      <div>
        <h4 class="steps-text" :class="{ displayText: hideStepsText }">
          Step {{ currentStep }} of {{ remainingSteps }}
        </h4>
        <!-- BODY & COMPONENTS -->
        <BeforePaymentInfo
          v-if="modalToDisplay === 0"
          :precheckIssueFlights="agreedToIssueFlights"
          @nextProvModal="getNameCheckData"
          @nextModal="(modal) => (modalToDisplay = modal)"
          @emitHideStepsText="(bool) => (hideStepsText = bool)"
          @issueFlightsChange="handleIssueFlightsCheckboxChange"
        />

        <NameCheck
          v-if="modalToDisplay === 1"
          ref="namecheckcomp"
          :account-info="accountInfo"
          :booking-names="bookingNames"
          :office-open="officeOpen"
          :booking="booking"
          @exitModal="closeModal"
          @nextModal="(modal) => (modalToDisplay = modal)"
        />

        <CancellationConditions
          v-if="modalToDisplay === 2"
          @nextModal="(modal) => (modalToDisplay = modal)"
          @exitModal="closeModal"
        />

        <PaymentOptions
          v-if="modalToDisplay === 3"
          :agreedToIssueFlights="agreedToIssueFlights"
          @nextModal="(modal) => (modalToDisplay = modal)"
          @exitModal="closeModal"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import PaymentOptions from "./payment-options";
import BeforePaymentInfo from "./before-payment-info";
import NameCheck from "./name-check";
import CancellationConditions from "./cancellation-conditions-template/index.vue";
import { getTravellingPassengers } from "../../../../../lib/utilities"

export default {
  components: {
    PaymentOptions,
    BeforePaymentInfo,
    NameCheck,
    CancellationConditions,
  },
  data() {
    return {
      modalToDisplay: 0,
      confirmationCheckBox: "false",
      bookingNames: null,
      currentStep: "1",
      remainingSteps: "",
      hideStepsText: false,
      agreedToIssueFlights: false,
    };
  },
  mounted() {
    if (this.accountInfo && this.accountInfo.fil === "P") {
      this.remainingSteps = "4";
    } else {
      this.remainingSteps = "3";
    }

    if (this.accountInfo) {
      if (
        this.accountInfo.balanceCostNoSymbol !== null &&
        this.accountInfo.balanceCostNoSymbol === "0.00"
      ) {
        this.hideStepsText = true;
      }
    }
  },
  updated() {
    if (this.accountInfo && this.accountInfo.fil === "P") {
      this.remainingSteps = "4";
    } else {
      this.remainingSteps = "3";
    }

    if (this.accountInfo) {
      if (
        this.accountInfo.balanceCostNoSymbol !== null &&
        this.accountInfo.balanceCostNoSymbol === "0.00"
      ) {
        this.hideStepsText = true;
      }
    }
  },
  watch: {
    modalToDisplay: function (modal) {
      if (this.accountInfo.fil === "P") {
        switch (modal) {
          case 0:
            this.currentStep = "1";
            break;
          case 1:
            this.currentStep = "2";
            break;
          case 2:
            this.currentStep = "3";
            break;
          case 3:
            this.currentStep = "4";
            break;
        }
      } else {
        switch (modal) {
          case 0:
            this.currentStep = "1";
            break;
          case 2:
            this.currentStep = "2";
            break;
          case 3:
            this.currentStep = "3";
            break;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      officeOpen: "account/getOfficeInfo",
      accountInfo: "booking/getAccount",
      booking: "booking/getBooking",
      paxNames: "booking/getBookingPassengers"
    }),
  },
  methods: {
    async showModal(params) {
      if (params && params.issueFlights) {
        this.agreedToIssueFlights = true
      }
      this.$refs["make-payment-ref"].show();
    },
    closeModal() {
      this.confirmationCheckBox = "false";
      this.$refs["make-payment-ref"].hide();
      this.modalToDisplay = 0;
    },
    getNameCheckData(modalNum) {
      this.bookingNames = this.paxNames
      // Eliminate FAO from displaying on passenger name list at payment:
      this.bookingNames = getTravellingPassengers(
        this.booking.user_information.names, this.bookingNames
      )
      this.modalToDisplay = modalNum;
    },
    handleIssueFlightsCheckboxChange(agree) {
      this.agreedToIssueFlights = agree
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>
